document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".toggle-txt").forEach(function (button) {
    button.addEventListener("click", function () {
      var container = this.closest(".text-wrapper");
      var shortTxt = container.querySelector(".short-txt");
      var fullTxt = container.querySelector(".full-txt");
      var textNode = this.childNodes[0];
      if (fullTxt.classList.contains("txt-hidden")) {
        fullTxt.classList.remove("txt-hidden");
        shortTxt.classList.add("txt-hidden");
        textNode.nodeValue = "Less ";
        container.classList.add("less");
      } else {
        fullTxt.classList.add("txt-hidden");
        shortTxt.classList.remove("txt-hidden");
        textNode.nodeValue = "More ";
        container.classList.remove("less");
      }
    });
  });
});

$(document).ready(function () {
    $(".video-slider").slick({
      slidesToShow: 2.1,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      dots: false,
      arrows: true,
      centerMode: false,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 1024, // iPad Pro and below
          settings: {
            slidesToShow: 2,
            centerMode: false,
          }
        },
        {
          breakpoint: 768, // Regular iPad and tablets
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        },
        {
          breakpoint: 576, // Mobile
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        }
      ]
    });
    $('.logo-slider').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024, // iPad Pro and below
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768, // Regular iPad and tablets
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 576, // Mobile
          settings: {
            slidesToShow: 1,
          }
        }
      ]
});
});